import React from 'react';
import './InfoItemLabel.less';

export const InfoItemLabel = ({text}) => {
	return <span className="info-item-label">{text}</span>
}
